const data = {
  'Selected': 'Избрани: {0} от {1}',
  'Uploading files': 'Качване {0}% от {1}',
  'File size error': '{0} е твърде голям, моля, качете файлове по-малко от {1}',
  'Upload failed': '{0} Грещка при качване',
  'Per page': '{0} На страница',
  'Folder': 'Папка',
  'Login failed, please try again': 'Грешка при вписване, опитайте отново',
  'Already logged in': 'Вече сте влезли.',
  'Please enter username and password': 'Моля въведете потребителско име и парола.',
  'Not Found': 'Не е намерено',
  'Not Allowed': 'Не е позволено',
  'Please log in': 'Моля впишете се',
  'Unknown error': 'Неизвестна грешка',
  'Add files': 'Добаве файлове',
  'New': 'Ново',
  'New name': 'Ново име',
  'Username': 'Потребителско име',
  'Password': 'Парола',
  'Login': 'Вписване',
  'Logout': 'Изход',
  'Profile': 'Профил',
  'No pagination': 'Няма пагинация',
  'Time': 'Време',
  'Name': 'Име',
  'Size': 'Размер',
  'Home': 'Начало',
  'Copy': 'Копиране',
  'Move': 'Изрежи',
  'Rename': 'Преименуване',
  'Required': 'Моля, попълнете това поле',
  'Zip': 'Архив',
  'Batch Download': 'Пакетно изтегляне',
  'Unzip': 'Разархивирай',
  'Delete': 'Изтриване',
  'Download': 'Изтегляне',
  'Copy link': 'Копирай линк',
  'Done': 'Завършено',
  'File': 'Файл',
  'Drop files to upload': 'Пускане на файлове за качване',
  'Close': 'Затвори',
  'Select Folder': 'Избери папка',
  'Users': 'Потребител',
  'Files': 'файлове',
  'Role': 'Права',
  'Cancel': 'Отказ',
  'Paused': 'Пауза',
  'Confirm': 'Потвърждение',
  'Create': 'Създай',
  'User': 'Потребител',
  'Admin': 'Администратор',
  'Save': 'Запази',
  'Read': 'Чете',
  'Write': 'Записва',
  'Upload': 'Качи',
  'Permissions': 'Разрешения',
  'Homedir': 'Главна директория',
  'Leave blank for no change': 'Оставете празно, за да няма промяна',
  'Are you sure you want to do this?': 'Сигурни ли сте, че искате да направите това?',
  'Are you sure you want to allow access to everyone?': 'Сигурни ли сте, че искате да разрешите достъп на всички?',
  'Are you sure you want to stop all uploads?': 'Сигурни ли сте, че искате да спрете всички качвания?',
  'Something went wrong': 'Нещо се обърка',
  'Invalid directory': 'Невалидна директория',
  'This field is required': 'Това поле е задължително',
  'Username already taken': 'Потребителско име вече е заето',
  'User not found': 'Потребителя не е намерен',
  'Old password': 'Стара парола',
  'New password': 'Нова парола',
  'Wrong password': 'грешна парола',
  'Updated': 'Обновено',
  'Deleted': 'изтрити',
  'Your file is ready': 'Вашия файл е готов',
  'View': 'View',
}

export default data

